import { compose } from 'redux'
import { connect } from 'react-redux'
import { withHandlers } from 'recompose'
import { firebaseConnect } from 'react-redux-firebase'
import { withStyles } from '@material-ui/core/styles'
import { timerStop } from 'utils/timer'
import { STAGE_TASK_CHOICE } from 'constants'
import styles from './BreakTimer.styles'

const stopDumoTimer = props => () => {
  const { firebase } = props

  timerStop()
  firebase.updateProfile({
    stage: STAGE_TASK_CHOICE,
    lastSeen: Date.now(),
  })
}

export default compose(
  firebaseConnect(props => [`users/${props.uid || ''}`]),
  connect(({ interactions, firebase }) => ({
    breakDesc: firebase.profile.breakDesc,
    countdownValue: interactions.countdownValue,
    uid: firebase.profile.uid || '',
  })),
  withHandlers({
    stopDumoTimer,
  }),
  withStyles(styles)
)



// WEBPACK FOOTER //
// ./src/components/BreakTimer/BreakTimer.enhancer.js